<template>
  <div>
    <div class="footer">
      <div class="footer-bottom">
        <div class="footer-left">
          <h2 class="title">联系我们</h2>
          <ul class="footer-intro">
            <li class="telephone">
              <img src="../../../assets/images/icon_tel.png" alt="">
              <span>020-37579981</span>
            </li>
            <li class="email">
              <img src="../../../assets/images/icon_email.png" alt="">
              <span>dengyunjia@gzyueyun.com</span>
            </li>
            <li class="time">
              <img src="../../../assets/images/icon_time.png" alt="">
              <span>周一至周五 AM:9:00~PM:18:00</span>
            </li>
          </ul>
          <p class="adress">
            <img src="../../../assets/images/icon_address.png" alt>
            <span>广州市越秀区先烈中路75号穗丰大厦B座202</span>
          </p>
        </div>
        <div class="footer-right">
          <div class="quick">
            <img src="../../../assets/images/code.png" alt="">
          </div>
        </div>
      </div>
      <div class="copyright">
        <a class="copy" href='http://beian.miit.gov.cn'>备案编号：粤ICP备19150625号-1 copyright@2018 格局云（广州）信息科技有限公司</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style lang="css" scoped>
  .footer{
    width: 100%;
    height: 350px;
    background: #000;
    color: #fff;
    display:flex;
    justify-content: center;
    align-items: center;
    flex-direction:column;
    margin-top: 150px;
  }
    
    .footer-bottom{
        width: 80%;
        font-size: 18px;
        display:flex;
        justify-content:space-around;
    }
      
      
    .footer-left .title{
        font-size:24px;
        margin-bottom:15px;
    }
          
    .footer-intro{
        display:flex;
    }
        
    .footer-intro li{
        padding: 15px;
    }
        
    .footer-intro li:first-child{
        padding-left: 0;
    }
          
    .copyright{
        margin-top:90px;
        font-size:14px;
        color: rgba(255, 255, 255, 0.5);
    }
    .copy{
        color: rgba(255, 255, 255, 0.5);

    }
      

</style>
